import { render } from "./EditSurveyGroup.vue?vue&type=template&id=41d8e5f4"
import script from "./EditSurveyGroup.vue?vue&type=script&lang=js"
export * from "./EditSurveyGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__